import { render, staticRenderFns } from "./camera_access.vue?vue&type=template&id=7dd32be8&scoped=true"
import script from "./camera_access.vue?vue&type=script&lang=js"
export * from "./camera_access.vue?vue&type=script&lang=js"
import style0 from "./camera_access.vue?vue&type=style&index=0&id=7dd32be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd32be8",
  null
  
)

export default component.exports